import { ReactNode } from "react";
import { ButtonVariations } from "../buttons/button";
import { WebsiteButton } from "../buttons/websiteButton";

export const WebsiteCTASubSection = ({
  minititle,
  title,
  text,
  ctaVariant,
  ctaText,
  ctaTo,
  minititleClassName = "",
  titleClassName = "",
  textClassName = "",
  ctaClassName = "",
}: {
  minititle: string;
  title: string;
  text: ReactNode;
  ctaVariant: ButtonVariations;
  ctaText: string;
  ctaTo: string;
  minititleClassName?: string;
  titleClassName?: string;
  textClassName?: string;
  ctaClassName?: string;
}) => {
  return (
    <div className="flex flex-col gap-6 lg:gap-8">
      <p className={`font-medium tracking-[2px] text-sm ${minititleClassName}`}>
        {minititle}
      </p>

      <p
        className={`mt-2 lg:mt-0 text-[32px] lg:text-4xl tracking-[-1px] leading-[44px] ${titleClassName}`}
      >
        {title}
      </p>

      <div className={`text-base lg:text-xl ${textClassName}`}>{text}</div>

      <WebsiteButton
        text={ctaText}
        variation={ctaVariant}
        to={ctaTo}
        className={`!px-6 !max-w-fit !py-[12px] lg:!py-[14px] ${ctaClassName}`}
      />
    </div>
  );
};
